<template>
  <div>
    <label v-show="editable" for="addThumbnail">
      <img
        class="preview"
        :src="thumbnail || productThumbnail || '/static/img/ico-image-chooser.svg'"
        alt="add product image"
      />
    </label>
    <input
      class="chooser"
      id="addThumbnail"
      type="file"
      accept="image/*"
      @change="handleFiles"
    />
    <div class="image-container">
      <div v-show="zoomed" class="background" @click="toggleZoom"></div>
      <img
        v-show="!editable"
        :class="zoomed ? 'zoom' : 'preview'"
        :src="thumbnail || productThumbnail || '/static/img/ico-image-chooser.svg'"
        alt="product image"
        @click="toggleZoom"
      />
    </div>
  </div>
</template>


<script>
/* eslint-disable no-console */

import Configuration from '@/js/Configuration';

/**
 * ProductThumbnail
 *
 * 1. add import & components
 * Props
 *  - editable : edit mode
 *  - product : productID for load thumbnail
 *  - productThumbnail : controll thumbnail on parent
 *  - zoom : zoom hover or not
 * Event
 *   - edited:thumbnail : change thumbnail
 */
export default {
  props: {
    editable: Boolean,
    productThumbnail: String,
    product: Object,
    zoom: Boolean,
  },
  data: () => ({
    thumbnail: null,
    zoomed: false,
  }),
  created() {
    if (this.product !== undefined) {
      this.fetchProductThumbnail();
    }
  },
  methods: {
    async fetchProductThumbnail() {
      const thumbnailUrl = `${Configuration.value('CSTORAGE_ADDRESS',
      )}/api/v1/cstorage/${this.product.productID}/thumbnail`;

      const thumbnail = await this.$http.get(thumbnailUrl, {
        headers: {
          Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
        },
      });

      if (thumbnail.status === 200) {
        this.thumbnail = thumbnail.data;
      }
    },
    handleFiles(event) {
      if (event.target.files && event.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.thumbnail = e.target.result;
          this.$emit('edited:thumbnail', this.thumbnail);
        };
        reader.readAsDataURL(event.target.files[0]);
      }
    },
    toggleZoom() {
      this.zoomed = !this.zoomed;
      if (this.zoomed) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    },
  },
};
</script>

<style scoped>
label {
  display: block;
}

.chooser {
  position: absolute !important;
  overflow: hidden;
  display: none;
}

.image-container {
  position: relative;
}

.preview {
  height: 50%;
  width: 50%;
}

.preview {
  transition: transform 0.2s;
  height: 100%;
  width: 100%;
  margin: 0 auto;
}

.zoom {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(25);
  transition: transform 0.2s;
  height: auto;
  width: auto;
  max-width: 30px;
  max-height: 30px;
  margin: 0 auto;
  z-index: 1000;
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  z-index: 999;
}

.hidden {
  display: none;
}
</style>




// WEBPACK FOOTER //
// src/components/product/ProductThumbnail.vue